export const getPermissionColDefs = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleActionCallback: (action: number, data: any) => void,
    isSetUpDisabled = false
) => [
    {
        field: 'fullName',
        headerName: 'User Name',
        headerClass: 'ag-admin-header',
        minWidth: 150,
        sortable: true,
        resizable: true,
        comparator: () => 0
    },
    {
        field: 'emailAddress',
        headerName: 'Email',
        headerClass: 'ag-admin-header',
        sortable: true,
        resizable: true,
        minWidth: 150,
        comparator: () => 0
    },
    {
        field: 'roles',
        headerName: 'Roles',
        cellRenderer: 'roleCellRenderer',
        headerClass: 'ag-admin-header',
        resizable: true,
        minWidth: 475,
        comparator: () => 0
    },
    {
        field: 'actions',
        headerName: 'Actions',
        width: 105,
        cellRenderer: 'actionCellRenderer',
        headerClass: 'ag-admin-header',
        resizable: false,
        cellRendererParams: {
            onAction: handleActionCallback,
            isSetUpDisabled
        }
    }
];

export const USER_GUEST = 'Guest';
